<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Student Fee Invoice" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <DateSelector v-model="Invoice.date" />
          </v-col>
          <v-col cols="12" sm="12">
            <v-autocomplete v-model="selectedProduct" hide-no-data ref="productSearch" outlined
              prepend-inner-icon="search" rounded dense :loading="loading" auto-select-first single-line hide-details
              clearable id="productSearch" :items="Products" item-text="name" return-object label="Select Fee Product">
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip v-if="item.isFee" color="pink" label text-color="white">
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  School Fee
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12">
            <div>Students</div>
            <v-list class="list-350">
              <template v-for="(row, index) in Students">
                <v-list-item :key="index">
                  <!-- <v-list-item-avatar>
                    <v-btn icon>
                      <v-icon color="red" @click="deleteRow(row)">delete</v-icon>
                    </v-btn>
                  </v-list-item-avatar> -->
                  <v-checkbox v-model="row.selectedStudent">
                    <template v-slot:label>
                      <v-list-item-content>
                        <v-list-item-title style="color: black" class="text-capitalize font-weight-bold">{{ row.fullName
                          }} <span>- Parent Pay: {{ getTotalParentPay(row.ClassStudents) | currency
                            }}</span></v-list-item-title>
                        <v-list-item-subtitle class="caption" v-if="!row.ClassRoomStudents.length">
                          <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                            Not Assign To Any Class Room
                          </v-chip>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="row && row.ClassStudents" class="font-weight-light">
                          <!-- <span v-for="(classRow, idx) in row.ClassStudents" :key="idx">{{ classRow.Class.name }}<span v-if="row.ClassStudents.length !== idx">, </span></span> -->
                          <div v-for="(classRow, idx) in row.ClassStudents" :key="idx">
                            {{ classRow.Class.name }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-checkbox>
                  <v-list-item-action-text>
                    <v-list-item-title v-if="row && row.ClassStudents" class="text-capitalize font-weight-bold">
                      <div v-for="(classRow, idx) in row.ClassStudents" :key="idx">
                        {{ getPrice(classRow) | currency }}
                        <!-- {{ classRow.Class.name }} -->
                      </div>
                      <!-- {{ getPrice(row.ClassStudents[0]) | currency }} -->
                    </v-list-item-title>
                  </v-list-item-action-text>
                </v-list-item>
              </template>
            </v-list>

          </v-col>
        </v-row>



      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
// import teacherService from "../service.js";
import productService from "@/modules/Product/service";
import studentService from "@/modules/Student/service.js";
// import classService from "@/modules/Classes/service.js";
import DateSelector from "@/components/DateSelector";
import invoiceService from "@/modules/Invoice/service.js";

export default {
  props: {
    createDialog: {
      default: false,
    },
    parent: {
      type: Object,
    },
  },
  name: "create-invoice",
  data() {
    return {
      Products: [],
      selectedProduct: null,
      Invoice: {
        date: this.$moment().toISOString(),
      },
      StudentList: [],
      Classes: [],
      Students: [],
      selectedStudent: [],
      loading: false,
      dialog: false,
      Teacher: null,
    };
  },
  components: {
    DateSelector,
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Teacher.name.$dirty) return errors;
      if (!this.$v.Teacher.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.Teacher = this.editTeacher;
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        // this.getTeacher();
        this.getStudents();
        this.getProduct();
      }
    },
  },
  methods: {
    getProduct() {
      this.loading = true;
      return productService.getAll({ isFee: true }).then((result) => {
        this.Products = result.data;
        this.loading = false;
      });
    },
    getTotalParentPay(obj) {
      let total = 0
      obj.map(row => {
        total += row.parentPay
      })
      return total
    },
    getPrice(classObj) {
      return classObj.parentPay + classObj.charity
    },
    getTotalPrice(classObj) {
      let total = 0
      classObj.map(row => {
        total += row.parentPay + row.charity
      })
      return total
      // return classObj.parentPay + classObj.charity
    },
    getStudents() {
      return studentService
        .getAll({ CustomerId: this.parent.id, hideLeft: true, classStudents: true })
        .then((response) => {
          console.log("response", response);
          this.Students = response.data;
          this.Students.map(student => {
            student.selectedStudent = true
          })
          return response;
        });
    },

    // getTeacher() {
    //   return teacherService.getById(this.Teacher.id).then((response) => {
    //     this.Teacher = response.data;
    //     console.log("response Teacher", this.Teacher);

    //     this.StudentList = this.Teacher.Students;
    //     return response;
    //   });
    // },
    submit() {
      this.Invoice.CustomerId = this.parent.id
      this.loading = true
      if (!this.selectedProduct) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: "Free product not selected",
          });
        this.loading = false
        return true
      }
      let detail = []
      this.Students.map(student => {
        if (student.selectedStudent) {
          student.ClassStudents.map(row => {
            let studentRow = {
              ProductId: this.selectedProduct.id,
              name: `${this.selectedProduct.name} - Parent Pay: ${row.parentPay} (${student.fullName})`,
              price: row.parentPay + row.charity,
              total: row.parentPay + row.charity,
              parentPay: row.parentPay,
              StudentId: student.id,
              description: row.Class.name,
              qty: 1,
              cost: 0,
              ClassRoomId: row.ClassRoomId,
              ClassId: row.Class.id
            }
            detail.push(studentRow)
          })
        }
      })
      this.Invoice.InvoiceDetails = detail
      if (this.Invoice.InvoiceDetails.length <= 0) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: "No student selected",
          });
        this.loading = false
        return true
      }
      console.log('invoice', this.Invoice)
      return invoiceService
        .create(this.Invoice)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Invoice was created!",
            });
          this.$emit('submit')
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log("error creating invoice", error);
          this.loadingSaveBtn = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 6000,
            })
            .fire({
              icon: "error",
              title: error.data.message,
            });
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Teacher = {
        name: null,
      };
    },
  },
};
</script>

<style scoped></style>
